import { Button, ButtonVariants, ChangeUserPassword, Sessions } from "@app/shared";
import { FC } from "react";
import { DashboardLayout } from "../../layouts";
import { PageContainer, PasswordInput } from "../../shared";
import { useModel } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { Pages } from "..";
import { toastError, toastSuccess } from "../../../helpers";

export const ChangePassword: FC = (props) => {
    const [changeUserPassword, helpers] = useModel(ChangeUserPassword);
    const navigate = useNavigate();

    const handleNavigateBack = () => {
        navigate(Pages.AccountDetails.getUrl());
    };

    const handleChangePasswordClick = async () => {
        try {
            await Sessions.changePassword(changeUserPassword as ChangeUserPassword);
            toastSuccess("Success", "Your Password has been changed!");
            setTimeout(() => {
                navigate(Pages.AccountDetails.getUrl());
            }, 1000);
        } catch (ex) {
            toastError("Error", (ex as object).toString());
        }
    };

    return (
        <DashboardLayout centerChildren="Account Details">
            <PageContainer title="Change Password Information">
                <PasswordInput label="Current Password" {...helpers.bindingsFor("currentPassword")} />
                <PasswordInput label="New Password" {...helpers.bindingsFor("newPassword")} />
                <PasswordInput label="Confirm New Password" {...helpers.bindingsFor("newPassword2")} />

                <div className="flex pt-5 gap-5 place-items-center justify-center">
                    <Button variant={ButtonVariants.Secondary} onClick={handleNavigateBack}>
                        Back
                    </Button>
                    <Button onClick={handleChangePasswordClick}>Change</Button>
                </div>
            </PageContainer>
        </DashboardLayout>
    );
};
